<template>
  <div id="solution">
    <div class="solution_title">产品及解决方案</div>
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <div class="max_box">
          <img :src="item.img" alt="" />
          <p>{{ item.name }}</p>
          <span>{{ item.txt }}</span>
          <div class="goTodetail" @click="goDetail(index)">
            <span>查看详情</span>
            <img
              src="https://www.bjecpower.com/camera/company/path2.png"
              alt=""
            />
          </div>
        </div>
        <div class="min_box">
          <div class="h5_tab" @click="clickTab(index)">
            <img :src="item.img" alt="" />
            <p>{{ item.name }}</p>
            <img
              class="h5_img"
              :src="
                item.type
                  ? 'https://www.bjecpower.com/camera/company/slicesBottom2.png'
                  : 'https://www.bjecpower.com/camera/company/slicesTop2.png'
              "
              alt=""
            />
          </div>
          <div
            class="h5_content"
            v-show="initSize() || (!initSize() && !item.type)"
          >
            <div class="h5_text">
              {{ item.txt }}
            </div>
            <span @click="goDetailaa(index)">查看详情</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "聚能运营方案",
          txt: "提供平台到设备的解决方案",
          path: "",
          img: "https://www.bjecpower.com/camera/company/newEnergy2.png",
          type: false,
        },
        {
          name: "智慧能源解决方案",
          txt: "从电源端解决运营能源成本及调度问题",
          path: "",
          img: "https://www.bjecpower.com/camera/company/operation2.png",
          type: true,
        },
        {
          name: "AI智能场站管理方案",
          txt: "解决运营商运营效率及用户体验问题",
          path: "",
          img: "https://www.bjecpower.com/camera/company/ai2.png",
          type: true,
        },
      ],
    };
  },
  methods: {
    goDetail(index) {
      if (this.initSize()) {
        if (index == 0) {
          this.$router.push({ path: "/Soluc" });
        }
        if (index == 1) {
          this.$router.push({ path: "/Solua" });
        }
        if (index == 2) {
          this.$router.push({ path: "/Solub" });
        }
        // alert("小傻瓜~");
      }
    },
    goDetailaa(index) {
    
      if (index == 0) {
        this.$router.push({ path: "/Soluc" });
      }
      if (index == 1) {
        this.$router.push({ path: "/Solua" });
      }
      if (index == 2) {
        this.$router.push({ path: "/Solub" });
      }
    },
    clickTab(index) {
      if (!this.initSize()) {
        this.list[index].type = !this.list[index].type;
        // document.getElementsByTagName('li')[index].style.margin = ''
      }
    },
    initSize() {
      return document.body.clientWidth > 768;
    },
  },
};
</script>

<style scoped>
#solution {
  width: 100%;
  height: 489.5px;
  box-sizing: border-box;
  padding: 64px 220px 95px 220px;
  background-image: url("https://www.bjecpower.com/camera/company/cp.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.solution_title {
  width: 100%;
  font-size: 32px;
  color: #191c27;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  text-align: center;
}
ul {
  display: flex;
  justify-content: space-between;
  /* width: 1000px; */
  margin: 56px auto 0px auto;
  /* background: rgba(55, 146, 230, 0.18); */
  position: relative;
}
li {
  width: 33.3%;
  background: #fff;
  height: 241px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 32px 35px 32px;
  position: absolute;
  position: relative;
  text-align: left;
  border: 1px solid #e5e5e5;

  top: 0;
  transition: 1s;
}
li:nth-child(1) {
  border-right: none;
}
li:nth-child(3) {
  border-left: none;
}
li:hover {
  box-shadow: 0px 2px 25px 0px rgba(55, 146, 230, 0.18);
  animation: top 0.5s linear;
  top: -30px;
}
@keyframes top {
  0% {
    top: 0;
  }
  100% {
    top: -30px;
  }
}
li:hover .goTodetail {
  display: block;
}
li > .max_box > img {
  width: 76px;
  height: 76px;
}
.min_box > .h5_tab > .h5_img {
  display: none;
  position: absolute;
  width: 15px;
  height: 8px;
  right: 15px;
  top: 26px;
}
li > .max_box > p {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  margin: 15px 0 10px 0;
}
li > .max_box > span {
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9ea5bb;
}
.goTodetail:hover {
  background: #016ed3;
}
.goTodetail {
  width: 100%;
  height: 35px;
  background: #0084ff;
  box-sizing: border-box;
  display: flex;
  line-height: 35px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: calc(50% - 35px);
  display: none;
  cursor: pointer;
}
.goTodetail > span {
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
}
.goTodetail > img {
  width: 4px;
  height: 8px;
  margin: 14.5px 0 0 6px;
}
.h5_text {
  display: none;
}
.min_box {
  display: none;
}
@media screen and (max-width: 768px) {
  .max_box {
    display: none;
  }
  #solution {
    padding: 0;
    background-image: none;
    margin-top: 50px;
    height: auto;
  }
  .solution_title {
    /* height: 22px; */
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    text-align: center;
  }
  ul {
    width:100%;
    margin-top: 24px;
    flex-direction: column;
  }
  li {
    width: 100%;
    margin: 0;
    padding: 0px;
    height: auto;
    border: none;
    box-shadow: 0px 2px 25px 0px rgba(55, 146, 230, 0.18);
  }
  li:hover {
    top: 0;
    animation: none;
  }
  .min_box {
    width: 100%;
    height: 100%;
    display: block;
  }
  .min_box > .h5_tab {
    height: 60px;
    width: 100%;
    background: #fff;
    display: flex;
    padding: 15px;
    box-sizing: border-box;
    border: none;
  }
  .min_box > .h5_tab > img {
    width: 32px;
    height: 31px;
  }
  .min_box > .h5_tab > p {
    margin: 0 0 0 17px;
    font-size: 17px;

    font-weight: 500;
    color: #191c27;
    line-height: 32px;
  }
  .min_box > .h5_tab > .h5_img {
    display: block;
  }
  .h5_content {
    /* display: none; */
    min-height: 127px;
    background: #f6f7f9;
    padding: 24px 15px;
    box-sizing: border-box;
  }
  .h5_content span {
    width: 104px;
    height: 40px;
    background: #0084ff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    display: inline-block;
    font-weight: 500;
    color: #ffffff;
  }
  .h5_text {
    display: block;
    font-size: 15px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #5a6073;
    margin-bottom: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/solution.vue